export default __webpack_public_path__ + "static/media/RESTAPISimUserGuideRemote_v1.7.01.41b3056f.pdf";